// @flow

import { Component } from "react";
import classNames from "classnames";
import { createFragmentContainer, graphql } from "react-relay";

import Emojify from "app/components/shared/Emojify";
import TeamLabels from "app/components/Teams/Labels";

type Props = {
  team: any,
  checked: boolean,
  disabled?: boolean,
  onChange: Function,
};

class MemberTeamRow extends Component<Props> {
  render() {
    const classes = classNames("block px1 pb1", {
      "muted cursor-not-allowed": this.props.disabled,
      "cursor-pointer": !this.props.disabled,
    });

    return (
      <div className="col-12 md-col-6 lg-col-4 py1">
        <label className={classes}>
          <div className="flex items-start">
            <div className="pr2" style={{ lineHeight: 1.75 }}>
              <input
                className="checkbox"
                type="checkbox"
                checked={this.props.checked}
                disabled={this.props.disabled}
                onChange={this.handleChange}
              />
            </div>
            <div className="flex flex-column" style={{ minWidth: 0 }}>
              <div
                className="flex items-center m0 relative"
                style={{ lineHeight: 1.75 }}
              >
                <Emojify
                  text={this.props.team.name}
                  className="semi-bold truncate"
                />
                <TeamLabels team={this.props.team} />
              </div>
              {this._renderDescription()}
            </div>
          </div>
        </label>
      </div>
    );
  }

  handleChange = () => {
    this.props.onChange(this.props.team);
  };

  _renderDescription() {
    if (!this.props.team.description) {
      return null;
    }

    return (
      <div className="m0 p0 dark-gray h5 regular" style={{ lineHeight: 1.4 }}>
        <Emojify text={this.props.team.description} />
      </div>
    );
  }
}

export default createFragmentContainer(MemberTeamRow, {
  team: graphql`
    fragment MemberTeamRow_team on Team {
      ...Labels_team
      id
      uuid
      name
      description
    }
  `,
});
